import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../../../gql/fragments'
import type { Entity } from '../../types'

const DOC = gql`
  ${fragments.occupant.DOC}
  query ClusterOccupants(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $clusterId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                clusterOccupants(clusterId: $clusterId) {
                  ...FragmentOccupant
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.ClusterOccupantsQuery,
    Entity[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'clusterOccupants',
                graphql.transformers.OUT.list(fragments.occupant.TRANSFORMER, {
                  onNullish: 'remove',
                }),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.ClusterOccupantsQuery,
  Entity[],
  graphql.schema.ClusterOccupantsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
